module.exports = __webpack_public_path__ + "static/media/icon-manage-class-remove.39e3e2e4.svg";